import styled from "styled-components";
import { breakpoints } from "../globalStyles";

export const AppContainer = styled.div`
  position: relative;
  display: grid;
  grid-template-rows: 56px 1fr;
  grid-template-columns: minmax(0, 1fr);
  background: var(--background-primary);
  padding: 0 50px;
  gap: 24px;

  @media ${breakpoints.md} {
    grid-template-rows: 48px 1fr;
    padding: 0 20px;
  }
`;

export const Center = styled.div`
  background: rgba(19, 19, 19, 1);
  display: flex;
  justify-content: center;
  align-items: center;
`;
